module.exports = __webpack_public_path__ + "static/img/otplatastarogduga.5d2ae8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/otplatastarogduga.png
// module id = Nq4W
// module chunks = 0